<h1 mat-dialog-title>{{ twistoUnavailabilityDialog[data.twistoAvailability].header }}</h1>
<mat-dialog-content>
  <div *ngFor="let line of twistoUnavailabilityDialog[data.twistoAvailability].content; let last = last">
    {{ line }}&nbsp;
    <a
      *ngIf="last && twistoUnavailabilityDialog[data.twistoAvailability].redirect"
      [routerLink]="twistoUnavailabilityDialog[data.twistoAvailability].redirect"
      >tutaj.</a
    >
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-button matDialogClose="close" cdkFocusInitial>Zamknij</button>
</mat-dialog-actions>
